import { defineDirective, IOmniaShell, LocaleString, Module, OmniaModuleId, shell, str } from "../omnia"
import { IStocksModuleContext, IStocksService } from "../types"

export function createStocksModule(): ng.IDirective {

    return defineDirective(StocksModule, "app/stocks/module/module.html");

};


export class StocksModule extends shell.Module implements IStocksModuleContext {

    static $inject = ["$scope", "OmniaShell", "OmniaStocksService"];

    constructor($scope: ng.IScope, shell: IOmniaShell, private stocksSvc: IStocksService) {

        super($scope, shell, "icon-stocks", str.Modules.Stocks, OmniaModuleId.Stocks);

    }

    $onInit() {
        this.register()
        this.setupCommands()
        this.refresh()
    }

    private register() {


        this.registerComponent("omnia-stocks-edit", {
            directive: "omnia-stocks-edit",
            blocking: true,
            width: 400
        });

    }

    setupCommands() {

        let prevYear = this.session.yearId - 1;

        this._commands = [
            {
                text: `Copy stocks from ${prevYear}` as LocaleString,
                icon: "duplicate",
                execute: () => this.copyStocksFromPrevYear(),
                canExecute: () => !this.shell.isReadOnly(p => p.stocks)
            }
        ]

    }

    refresh() {
        return this.stocksSvc.refresh()
    }

    get module(): Module {
        return this;
    }

    copyStocksFromPrevYear() {

        this.shell.showComponentAsDialog("omnia-stocks-copy-dialog", null, {
            size: "lg",
        });

    }

}
